// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

body::ng-deep {
  overflow-y: hidden !important;
}

.chat-header {
  height: 50px;
}

.chat-header,
.chat-content {
  width: 90%;
  display: flex;
  justify-content: space-evenly;
}

.wrapper {
  display: flex;
  height: 100%;
  flex-direction: row;
  justify-content: stretch;
}

.chat-sidebar {
  max-width: 320px;
  height: 100%;
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;
}

.chatBotstyle {
  display: flex;
  flex-direction: row;
  width: 100% !important;
  height: 100%;
}

.hide {
  display: none;
}

.fa {
  cursor: pointer;
}

.chat-box-wrapper {
  position: relative;
  display: flexbox;
  width: 90%;
}

.chat-left-content {
  background: #fff;
  min-width: 280px;
  overflow-y: auto;
  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */
  /* box-shadow:3px 0px #e9e9e9; */
}

.chat-right-content {
  /* margin-left:20px; */
  /* width: clamp(300px,150vw,70vw); */
  min-width: 70%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: space-evenly;
}

#title {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-evenly;
  margin: 10px 0px;
  font-size: 16px;
  font-weight: bold;
}

.chat-history-list {
  height: 80vh;
  overflow-y: auto;
}

.chat-history-list ul {
  margin: 10px 0px;
  padding: 0px 10px;
  list-style: none;
  display: flex;
  flex-direction: column;
  line-height: 1.2rem;
}
.chat-history-list ul li {
  display: inline-flex;
  justify-content: space-evenly;
  align-items: baseline;
}
.chat-history-list ul li label:first-child {
  display: inline-block;
  background: #eee;
  color: #666;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font-size: 0.9rem;
  min-height: 25px;
  padding: 10px 10px;
  margin-bottom: 10px;
  width: 90%;
}
.chat-history-list ul li label:last-child {
  margin: 0% 3%;
  display: inline-block;
  width: 5%;
  padding-left: 2%;
}

#chat-list-content {
  position: fixed;
  /* bottom:90px; */
  /* width:clamp(300px,198vw,68vw); */
  margin-top: 75px;
  width: 60%;
  padding: 0% 2%;
  /* overflow-y: auto;
    height: 100vh;
    top: 70px; */
  font-size: 0.9rem !important;
  /*  display: flex;
    justify-content: space-evenly; */
}

#chat-list {
  position: relative;
  overflow-y: auto;
  width: 95%;
  height: 80vh;
  padding-right: 5px;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}

#chat-list::-webkit-scrollbar {
  display: none;
}

.chat-list-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding: 0px 10px;
}

#chat-message-enter-box {
  /* position: fixed; */
  background: #fff;
  width: 60%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;
  height: 51px;
  z-index: 1;
  /* top:65px; */
}
#chat-message-enter-box form {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
#chat-message-enter-box textarea {
  width: 100% !important;
  border: none;
  padding: 10px;
  color: #666;
  font-size: 1em;
  resize: none;
  height: 55px;
}
#chat-message-enter-box span {
  display: inline-block;
  color: #666;
  width: 100% !important;
  padding: 10px;
  color: #666;
  font-size: 1em;
  min-height: 55px;
}

/* .chat-header > span{
    display: inline-block;
        color: #666;
        width: 90% !important;
        padding: 10px;
        color: #666;
        font-size:1em;
        min-height:100px;
} */
.fa-cloud,
.fa-user-circle {
  color: #9da0a3;
  margin-top: 5px;
  font-size: 30px !important;
}

app-toggle-icon::ng-deep .fa-microphone-slash,
.fa-microphone-slash {
  opacity: 0.5 !important;
}

textarea::placeholder {
  color: rgb(182, 182, 182) !important;
}

.question {
  /* background: #9da0a3;   */
  /* background: #01488f; */
  min-height: 50px;
  padding: 15px 18px;
  background: #fff;
  color: #000;
  font-weight: bold;
  margin-bottom: 8px;
  width: 100%;
  position: relative;
  box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  /* box-shadow: 2px 2px 3px #000; */
  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */
  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */
}
.question:hover {
  border-left-color: #3498db;
  transform: translateX(2px);
}

/* .question::before{
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left:-15px;
    right:auto;
    top:10px;
    bottom: auto;
    border:15px solid;
    border-color:var(--primaryColor) transparent transparent transparent;


} */
.question.align-right {
  /* background: #f2fcff; */
  background: #9da0a3;
  min-height: 50px;
  border-radius: 5px;
  padding: 10px;
  color: #fff;
  margin-bottom: 10px;
  width: 100%;
  margin-left: 50%;
  margin-right: 15px;
  position: relative;
}

.question.align-right::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: auto;
  right: -20px;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #848a92 transparent transparent transparent;
}

video {
  margin: 10px 0px;
}

.answer {
  background: #fff;
  min-height: 50px;
  padding: 18px 20px;
  color: #666;
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
  box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;
  transition: box-shadow 0.2s ease;
}
.answer:hover {
  box-shadow: rgba(14, 63, 126, 0.08) 0px 0px 0px 1px, rgba(42, 51, 69, 0.06) 0px 2px 2px -0.5px, rgba(42, 51, 70, 0.06) 0px 4px 4px -1.5px, rgba(42, 51, 70, 0.06) 0px 8px 8px -3px, rgba(14, 63, 126, 0.06) 0px 16px 16px -6px, rgba(14, 63, 126, 0.06) 0px 32px 32px -12px;
}

.answer-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 10px;
  gap: 15px;
  min-height: 30px;
  padding-top: 5px;
  background: #fff;
}
.answer-header span {
  font-weight: bold;
}

.audio {
  cursor: pointer;
}

ul li {
  display: inline;
  list-style: none;
  margin: 5px 10px;
  display: inline-block;
  cursor: pointer;
}

.menu-list {
  position: relative;
}
.menu-list ul {
  position: absolute;
  top: -10px;
  right: 0px;
  width: max-content;
}
.menu-list ul li {
  margin: 10px 10px;
  display: inline-block;
  cursor: pointer;
}
.menu-list ul li:hover .fa {
  color: #008cb3;
}
.menu-list ul.active {
  display: block;
}
.menu-list label {
  width: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.dropdown-menu {
  left: -55px !important;
}

.dropdown-item {
  padding: 0px !important;
}
.dropdown-item li {
  margin: 5px 0px !important;
  font-size: 12px !important;
  width: 100%;
  padding: 5px 10px;
}
.dropdown-item li:hover {
  background: var(--primarylightColor);
  color: var(--primaryColor);
}

/*.answer-content::before{
    content: " ";
    position: absolute;
    width: 0;
    height: 0;
    left:-25px;
    right:auto;
    top:-25px;
    bottom: auto;
    border: 21px solid;
    border-color: #fff transparent transparent transparent;

} */
.answer-content {
  position: relative;
  padding: 8px 0px;
  line-height: 1.6;
  font-size: 0.9rem;
  color: #111;
}

.answer-content::ng-deep ol {
  padding: 10px !important;
}

.feedback::before {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  left: -25px;
  right: auto;
  top: 0px;
  bottom: auto;
  border: 21px solid;
  border-color: #fff transparent transparent transparent;
}

.feedback {
  position: relative;
  color: #111;
}
.feedback ol {
  padding: 30px;
}

.chat-icon {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  background: var(--primarylightColor);
}
.chat-icon .bot-icon {
  margin-top: 5px;
}
.chat-icon img {
  border-radius: 100%;
}

.username {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background: var(--primarylightColor);
  color: var(--primaryColor);
  vertical-align: middle;
  text-align: center;
  font-size: 22px;
  margin-right: 5px;
  display: inline-block;
  text-transform: uppercase;
}

#chatForm {
  width: 100%;
  height: inherit;
}

#chatForm > span {
  width: 90%;
  height: inherit;
  margin-left: 10px;
}

#expand-collapse {
  position: relative;
  margin-top: 25px;
  height: 15px;
}
#expand-collapse i {
  background: #fff;
  padding: 10px;
}
#expand-collapse .fa {
  font-size: 1.5em !important;
  transform: rotate(180deg) translateX(0px);
  transform-origin: 50% 20%;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #fff;
}

#chat-content-wrapper {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
#chat-content-wrapper header {
  background: transparent !important;
  padding: 5px !important;
}

.chat-history-list::ng-deep .tabs-container {
  height: 80vh !important;
}
.chat-history-list::ng-deep .tabs-container ul {
  display: flex;
}
.chat-history-list::ng-deep .tabs-container li {
  width: 50%;
  font-size: 0.9em;
}
.chat-history-list::ng-deep .tabs-container app-tab .pane {
  padding: 0px !important;
}
.chat-history-list::ng-deep .tabs-container app-tab li {
  width: 100%;
}

#voice-message {
  width: 80% !important;
  position: relative;
  background: #fff;
  margin-top: -50px;
  margin-left: 10px;
  padding-right: 10px;
  height: 50px;
}
#voice-message span {
  display: inline-block;
  color: #999;
}

#chat-tools {
  display: flex;
  list-style-type: none;
  width: 60px;
  flex-direction: row;
  gap: 20px;
  padding: 0px;
  margin: 0px;
  position: relative;
  right: 10px;
}
#chat-tools .fa-paper-plane {
  font-size: 17px !important;
}

[hidden] {
  display: none !important;
}

.comment-area-box::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 1px;
  left: 99%;
  box-sizing: border-box;
  border: 10px solid rgba(0, 0, 0, 0.5);
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(135deg);
  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);
}

.comment-area-box {
  display: none;
  background: #fff;
  padding: 15px 10px 5px;
  width: 80%;
}
.comment-area-box label {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.comment-area-box textarea {
  resize: none;
}
.comment-area-box .form-btns {
  width: 100%;
  display: flex;
  margin: 5px 0px;
}
.comment-area-box .form-btns .btn:first-child {
  border: 1px solid #dbdbdb;
  background: #fff !important;
  color: #000 !important;
}
.comment-area-box .form-btns .btn {
  --bs-btn-line-height: 1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--primaryColor);
  margin-right: 15px;
  border: none;
  cursor: pointer;
  font-family: "Noto Sans", sans-serif;
}

.comment-area-box.is-active {
  display: flex;
  margin-top: 10px;
  align-items: center;
}

.comment-form {
  margin-left: 10px;
  margin-top: 10px;
}
.comment-form label {
  font-size: 0.9rem;
}
.comment-form textarea {
  margin-right: 25px;
}
.comment-form .comments-field {
  margin-top: 10px;
}
.comment-form .comments-field .form-btns {
  float: right;
}
.comment-form .button:hover {
  background: var(--primaryColor) !important;
  color: #fff !important;
}

.chat-icon:has(> .bot-icon) {
  position: sticky;
  top: 0;
  margin-bottom: 40px;
}

::ng-deep .formatted-table {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-size: 14px;
}

::ng-deep .formatted-table th {
  background: linear-gradient(135deg, #34495e, #2c3e50);
  color: white;
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  border: none;
}

::ng-deep .formatted-table td {
  padding: 12px;
  border-bottom: 1px solid #ecf0f1;
  border-right: 1px solid #ecf0f1;
  vertical-align: top;
  transition: background-color 0.2s ease;
}

::ng-deep .formatted-table tr:hover td {
  background-color: #f8f9fa;
}

::ng-deep .formatted-table tr:nth-child(even) td {
  background-color: #fdfdfd;
}

::ng-deep .formatted-table tr:last-child td {
  border-bottom: none;
}

::ng-deep .formatted-table td:last-child {
  border-right: none;
}

/* Heading Styles */
::ng-deep .formatted-heading {
  color: #2c3e50;
  margin: 15px 0 15px 0;
  font-weight: 600;
  position: relative;
}

::ng-deep .formatted-heading.h1 {
  font-size: 1.5em;
  border-bottom: 3px solid #3498db;
  padding-bottom: 10px;
}

::ng-deep .formatted-heading.h2 {
  font-size: 1em;
  border-bottom: 2px solid #3498db;
  padding-bottom: 8px;
  line-height: 2;
}

::ng-deep .formatted-heading.h3 {
  font-size: 1em;
  color: #34495e;
  line-height: 2;
}

::ng-deep .formatted-heading.h4 {
  font-size: 1.2em;
  color: #34495e;
}

::ng-deep .formatted-heading.h5 {
  font-size: 1.1em;
  color: #34495e;
}

::ng-deep .formatted-heading.h6 {
  font-size: 1em;
  color: #34495e;
  text-transform: uppercase;
  letter-spacing: 1px;
}

::ng-deep .formatted-list {
  margin-top: -1.5rem;
}

.timestamp-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 30px;
  padding: 0 10px;
}
.timestamp-wrapper .timestamp-icon {
  opacity: 0.7;
}

@media screen and (max-width: 640px) {
  .chat-icon:has(> .bot-icon) {
    position: sticky;
    top: 0;
    margin-bottom: 40px;
  }
  .chat-list-row {
    width: 98%;
  }
  .answer-header {
    justify-content: flex-end;
  }
  .menu-list {
    margin-top: 10px;
  }
}
@media screen and (min-width: 768px) and (max-width: 960px) {
  #chat-list-content {
    padding: 1% 3% 0% 1% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/summarize/summarize-data-list/summarize-data-list.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAGA;;EAEE,UAAA;EACA,aAAA;EACA,6BAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gDAAA;AAAF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;AADF;;AAIA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gDAAA;EACA,gCAAA;AADF;;AAIA;EACE,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;AAGE;EACE,oBAAA;EACA,6BAAA;EACA,qBAAA;AADJ;AAGI;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AADN;AAII;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;AAFN;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA;;gBAAA;EAGA,4BAAA;EACA;oCAAA;AAHF;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;AAJF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AALF;;AAUA;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,UAAA;EAEA,cAAA;AARF;AASE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AAPJ;AAUE;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AARJ;AAWE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AATJ;;AAaA;;;;;;;;GAAA;AAUA;;EAEE,cAAA;EACA,eAAA;EACA,0BAAA;AAXF;;AAcA;;EAEE,uBAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EAGE,2BAAA;EACA,yBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAEA,WAAA;EAEA,kBAAA;EACA,mTAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,kCAAA;EACA,kCAAA;EACA,uDAAA;EACA,wDAAA;AAhBF;AAkBE;EACE,0BAAA;EACA,0BAAA;AAhBJ;;AAuBA;;;;;;;;;;;;;GAAA;AAcA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,yDAAA;AApBF;;AAwBA;EACE,gBAAA;AArBF;;AAwBA;EACE,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EAIA,kDAAA;EACA,2QAAA;EACA,gCAAA;AAzBF;AA2BE;EACE,2QAAA;AAzBJ;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA1BF;AA4BE;EACE,iBAAA;AA1BJ;;AA8BA;EACE,eAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,kBAAA;AA3BF;AA6BE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;AA3BJ;AA6BI;EACE,iBAAA;EACA,qBAAA;EACA,eAAA;AA3BN;AA+BM;EACE,cAAA;AA7BR;AAkCE;EACE,cAAA;AAhCJ;AAmCE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAjCJ;;AAuCA;EACE,sBAAA;AApCF;;AAwCA;EACE,uBAAA;AArCF;AAuCE;EACE,0BAAA;EACA,0BAAA;EACA,WAAA;EACA,iBAAA;AArCJ;AAwCE;EACE,oCAAA;EACA,0BAAA;AAtCJ;;AA0CA;;;;;;;;;;;;GAAA;AAcA;EACE,kBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAzCF;;AA+CA;EACE,wBAAA;AA5CF;;AAiDA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,sDAAA;AA9CF;;AAiDA;EACE,kBAAA;EAEA,WAAA;AA/CF;AAkDE;EACE,aAAA;AAhDJ;;AAoDA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;AAjDF;AAmDE;EACE,eAAA;AAjDJ;AAoDE;EACE,mBAAA;AAlDJ;;AAsDA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAnDF;;AAuDA;EACE,WAAA;EACA,eAAA;AApDF;;AAwDA;EACE,UAAA;EACA,eAAA;EACA,iBAAA;AArDF;;AAyDA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AAtDF;AAwDE;EACE,gBAAA;EACA,aAAA;AAtDJ;AAyDE;EACE,2BAAA;EACA,yCAAA;EACA,yBAAA;AAvDJ;;AA4DA;EACE,UAAA;AAzDF;;AA4DA,UAAA;AACA;EACE,gBAAA;AAzDF;;AA4DA,WAAA;AACA;EACE,gBAAA;AAzDF;;AA4DA,oBAAA;AACA;EACE,gBAAA;AAzDF;;AA4DA;EACE,aAAA;EACA,6BAAA;EACA,WAAA;AAzDF;AA2DE;EACE,kCAAA;EACA,uBAAA;AAzDJ;;AA6DA;EACE,uBAAA;AA1DF;AA4DE;EACE,aAAA;AA1DJ;AA6DE;EACE,UAAA;EACA,gBAAA;AA3DJ;AA+DI;EACE,uBAAA;AA7DN;AAgEI;EACE,WAAA;AA9DN;;AAoEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAjEF;AAmEE;EACE,qBAAA;EACA,WAAA;AAjEJ;;AAqEA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AAlEF;AAoEE;EACE,0BAAA;AAlEJ;;AAsEA;EACE,wBAAA;AAnEF;;AAsEA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,qCAAA;EACA,+CAAA;EACA,qBAAA;EACA,yBAAA;EACA,8CAAA;AAnEF;;AAsEA;EAKE,aAAA;EACA,gBAAA;EACA,sBAAA;EAEA,UAAA;AAxEF;AA0EE;EACE,kCAAA;EAAA,6BAAA;AAxEJ;AA2EE;EACE,YAAA;AAzEJ;AA4EE;EACE,WAAA;EACA,aAAA;EACA,eAAA;AA1EJ;AA4EI;EACE,yBAAA;EACA,2BAAA;EACA,sBAAA;AA1EN;AA6EI;EACE,oCAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;AA3EN;;AAkFA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AA/EF;;AAkFA;EACE,iBAAA;EACA,gBAAA;AA/EF;AAiFE;EACE,iBAAA;AA/EJ;AAkFE;EACE,kBAAA;AAhFJ;AAmFE;EACE,gBAAA;AAjFJ;AAmFI;EACE,YAAA;AAjFN;AAsFI;EACE,0CAAA;EACA,sBAAA;AApFN;;AAyFA;EACE,gBAAA;EACA,MAAA;EACA,mBAAA;AAtFF;;AAyFA;EACE,yBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;AAtFF;;AAyFA;EACE,qDAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AAtFF;;AAyFA;EACE,aAAA;EACA,gCAAA;EACA,+BAAA;EACA,mBAAA;EACA,sCAAA;AAtFF;;AAyFA;EACE,yBAAA;AAtFF;;AAyFA;EACE,yBAAA;AAtFF;;AAyFA;EACE,mBAAA;AAtFF;;AAyFA;EACE,kBAAA;AAtFF;;AAyFA,mBAAA;AACA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAtFF;;AAyFA;EACE,gBAAA;EACA,gCAAA;EACA,oBAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AAtFF;;AAyFA;EACE,gBAAA;EACA,cAAA;AAtFF;;AAyFA;EACE,gBAAA;EACA,cAAA;AAtFF;;AAyFA;EACE,cAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AAtFF;;AAyFA;EACE,mBAAA;AAtFF;;AAyFA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AAtFF;AAwFE;EACE,YAAA;AAtFJ;;AA0FA;EAEE;IACE,gBAAA;IACA,MAAA;IACA,mBAAA;EAxFF;EA2FA;IACE,UAAA;EAzFF;EA4FA;IACE,yBAAA;EA1FF;EA6FA;IACE,gBAAA;EA3FF;AACF;AA8FA;EACE;IACE,+BAAA;EA5FF;AACF","sourcesContent":[":host {\n  width: 100%;\n}\n\nbody::ng-deep {\n  overflow-y: hidden !important;\n}\n\n.chat-header {\n  height: 50px;\n\n}\n\n.chat-header,\n.chat-content {\n  width: 90%;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.wrapper {\n  display: flex;\n  height: 100%;\n  flex-direction: row;\n  justify-content: stretch;\n}\n\n.chat-sidebar {\n  max-width: 320px;\n  height: 100%;\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 0px 2.6px;\n}\n\n\n.chatBotstyle {\n  display: flex;\n  flex-direction: row;\n  width: 100% !important;\n  height: 100%;\n}\n\n.hide {\n  display: none;\n}\n\n.fa {\n  cursor: pointer;\n}\n\n.chat-box-wrapper {\n  position: relative;\n  display: flexbox;\n  width: 90%;\n}\n\n.chat-left-content {\n  background: #fff;\n  min-width: 280px;\n  overflow-y: auto;\n  /* box-shadow:2px 0px 0px rgba(0, 0, 0, 0.21); */\n  /* box-shadow:3px 0px #e9e9e9; */\n}\n\n.chat-right-content {\n  /* margin-left:20px; */\n  /* width: clamp(300px,150vw,70vw); */\n  min-width: 70%;\n  width: 100%;\n  overflow-y: auto;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n#title {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  justify-content: space-evenly;\n  margin: 10px 0px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.chat-history-list {\n  height: 80vh;\n  overflow-y: auto;\n}\n\n.chat-history-list ul {\n  margin: 10px 0px;\n  padding: 0px 10px;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2rem;\n\n  & li {\n    display: inline-flex;\n    justify-content: space-evenly;\n    align-items: baseline;\n\n    & label:first-child {\n      display: inline-block;\n      background: #eee;\n      color: #666;\n      border-radius: 10px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      cursor: pointer;\n      font-size: .9rem;\n      min-height: 25px;\n      padding: 10px 10px;\n      margin-bottom: 10px;\n      width: 90%;\n    }\n\n    & label:last-child {\n      margin: 0% 3%;\n      display: inline-block;\n      width: 5%;\n      padding-left: 2%;\n    }\n  }\n}\n\n#chat-list-content {\n  position: fixed;\n  /* bottom:90px; */\n  /* width:clamp(300px,198vw,68vw); */\n  margin-top: 75px;\n  width: 60%;\n  padding: 0% 2%;\n  /* overflow-y: auto;\n    height: 100vh;\n    top: 70px; */\n  font-size: .9rem !important;\n  /*  display: flex;\n    justify-content: space-evenly; */\n}\n\n#chat-list {\n  position: relative;\n  overflow-y: auto;\n  width: 95%;\n  height: 80vh;\n  padding-right: 5px;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n\n}\n\n#chat-list::-webkit-scrollbar {\n  display: none;\n}\n\n.chat-list-row {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n  padding: 0px 10px;\n}\n\n\n\n#chat-message-enter-box {\n  /* position: fixed; */\n  background: #fff;\n  width: 60%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  border-radius: 5px;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n  height: 51px;\n  z-index: 1;\n\n  /* top:65px; */\n  & form {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    width: 100%;\n  }\n\n  & textarea {\n    width: 100% !important;\n    border: none;\n    padding: 10px;\n    color: #666;\n    font-size: 1em;\n    resize: none;\n    height: 55px;\n  }\n\n  & span {\n    display: inline-block;\n    color: #666;\n    width: 100% !important;\n    padding: 10px;\n    color: #666;\n    font-size: 1em;\n    min-height: 55px;\n  }\n}\n\n/* .chat-header > span{\n    display: inline-block;\n        color: #666;\n        width: 90% !important;\n        padding: 10px;\n        color: #666;\n        font-size:1em;\n        min-height:100px;\n} */\n\n.fa-cloud,\n.fa-user-circle {\n  color: #9da0a3;\n  margin-top: 5px;\n  font-size: 30px !important;\n}\n\napp-toggle-icon::ng-deep .fa-microphone-slash,\n.fa-microphone-slash {\n  opacity: 0.5 !important;\n}\n\ntextarea::placeholder {\n  color: rgb(182, 182, 182) !important;\n}\n\n.question {\n  // background:#6089ca;\n  //  background:var(--primaryColor);\n  /* background: #9da0a3;   */\n  /* background: #01488f; */\n  min-height: 50px;\n  // border-radius:5px;\n  padding: 15px 18px;\n  background: #fff;\n  color: #000;\n  font-weight: bold;\n  margin-bottom: 8px;\n  //margin-bottom:10px;\n  width: 100%;\n  // margin-left:15px;\n  position: relative;\n  box-shadow: rgba(14, 63, 126, 0.06) 0px 0px 0px 1px, rgba(42, 51, 70, 0.03) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 2px 2px -1px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.03) 0px 5px 5px -2.5px, rgba(42, 51, 70, 0.03) 0px 10px 10px -5px, rgba(42, 51, 70, 0.03) 0px 24px 24px -8px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: all 0.2s ease;\n  border-left: 3px solid transparent;\n  /* box-shadow: 2px 2px 3px #000; */\n  /* box-shadow: rgba(25, 118, 210, 0.35) 0px 5px 15px; */\n  /* box-shadow: rgba(109, 129, 153, 0.35) 0px 5px 15px; */\n\n  &:hover {\n    border-left-color: #3498db;\n    transform: translateX(2px);\n  }\n\n\n\n}\n\n/* .question::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-15px;\n    right:auto;\n    top:10px;\n    bottom: auto;\n    border:15px solid;\n    border-color:var(--primaryColor) transparent transparent transparent;\n\n\n} */\n.question.align-right {\n  /* background: #f2fcff; */\n  background: #9da0a3;\n  min-height: 50px;\n  border-radius: 5px;\n  padding: 10px;\n  color: #fff;\n  margin-bottom: 10px;\n  width: 100%;\n  margin-left: 50%;\n  margin-right: 15px;\n  position: relative;\n}\n\n.question.align-right::before {\n  content: \" \";\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: auto;\n  right: -20px;\n  top: 0px;\n  bottom: auto;\n  border: 21px solid;\n  border-color: #848a92 transparent transparent transparent;\n\n}\n\nvideo {\n  margin: 10px 0px;\n}\n\n.answer {\n  background: #fff;\n  min-height: 50px;\n  // border-radius:5px;\n  padding: 18px 20px;\n  color: #666;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 12px;\n  // margin-left:19px;\n  // box-shadow: 1px 0px 3px #5555556e;\n  //    border: 1px solid #c8c8c8;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n  box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;\n  transition: box-shadow 0.2s ease;\n\n  &:hover {\n    box-shadow: rgba(14, 63, 126, 0.08) 0px 0px 0px 1px, rgba(42, 51, 69, 0.06) 0px 2px 2px -0.5px, rgba(42, 51, 70, 0.06) 0px 4px 4px -1.5px, rgba(42, 51, 70, 0.06) 0px 8px 8px -3px, rgba(14, 63, 126, 0.06) 0px 16px 16px -6px, rgba(14, 63, 126, 0.06) 0px 32px 32px -12px;\n  }\n}\n\n.answer-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-right: 10px;\n  gap: 15px;\n  min-height: 30px;\n  padding-top: 5px;\n  background: #fff;\n\n  span {\n    font-weight: bold;\n  }\n}\n\n.audio {\n  cursor: pointer;\n}\n\nul li {\n  display: inline;\n  list-style: none;\n  margin: 5px 10px;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.menu-list {\n  position: relative;\n\n  & ul {\n    position: absolute;\n    top: -10px;\n    right: 0px;\n    width: max-content;\n\n    li {\n      margin: 10px 10px;\n      display: inline-block;\n      cursor: pointer;\n    }\n\n    li:hover {\n      .fa {\n        color: #008cb3;\n      }\n    }\n  }\n\n  & ul.active {\n    display: block;\n  }\n\n  & label {\n    width: 20px;\n    display: flex;\n    justify-content: center;\n    cursor: pointer;\n  }\n\n\n}\n\n.dropdown-menu {\n  left: -55px !important;\n  // top:-100px !important;\n}\n\n.dropdown-item {\n  padding: 0px !important;\n\n  li {\n    margin: 5px 0px !important;\n    font-size: 12px !important;\n    width: 100%;\n    padding: 5px 10px;\n  }\n\n  li:hover {\n    background: var(--primarylightColor);\n    color: var(--primaryColor);\n  }\n}\n\n/*.answer-content::before{\n    content: \" \";\n    position: absolute;\n    width: 0;\n    height: 0;\n    left:-25px;\n    right:auto;\n    top:-25px;\n    bottom: auto;\n    border: 21px solid;\n    border-color: #fff transparent transparent transparent;\n\n} */\n\n.answer-content {\n  position: relative;\n  // margin-top:25px;\n  padding: 8px 0px;\n  line-height: 1.6;\n  font-size: .9rem;\n  color: #111;\n\n  // font-family: sans-serif;\n\n}\n\n.answer-content::ng-deep ol {\n  padding: 10px !important;\n}\n\n\n\n.feedback::before {\n  content: \" \";\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: -25px;\n  right: auto;\n  top: 0px;\n  bottom: auto;\n  border: 21px solid;\n  border-color: #fff transparent transparent transparent;\n}\n\n.feedback {\n  position: relative;\n\n  color: #111;\n\n  // font-family: sans-serif;\n  & ol {\n    padding: 30px;\n  }\n}\n\n.chat-icon {\n  width: 35px;\n  height: 35px;\n  border-radius: 100%;\n  background: var(--primarylightColor);\n\n  .bot-icon {\n    margin-top: 5px;\n  }\n\n  img {\n    border-radius: 100%;\n  }\n}\n\n.username {\n  width: 36px;\n  height: 36px;\n  border-radius: 100%;\n  background: var(--primarylightColor);\n  color: var(--primaryColor);\n  vertical-align: middle;\n  text-align: center;\n  font-size: 22px;\n  margin-right: 5px;\n  display: inline-block;\n  text-transform: uppercase;\n\n}\n\n#chatForm {\n  width: 100%;\n  height: inherit;\n\n}\n\n#chatForm>span {\n  width: 90%;\n  height: inherit;\n  margin-left: 10px;\n\n}\n\n#expand-collapse {\n  position: relative;\n  margin-top: 25px;\n  height: 15px;\n\n  i {\n    background: #fff;\n    padding: 10px;\n  }\n\n  .fa {\n    font-size: 1.5em !important;\n    transform: rotate(180deg) translateX(0px);\n    transform-origin: 50% 20%;\n  }\n\n}\n\n::-webkit-scrollbar {\n  width: 3px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #fff;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #fff;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #fff;\n}\n\n#chat-content-wrapper {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n\n  header {\n    background: transparent !important;\n    padding: 5px !important;\n  }\n}\n\n.chat-history-list::ng-deep .tabs-container {\n  height: 80vh !important;\n\n  ul {\n    display: flex;\n  }\n\n  li {\n    width: 50%;\n    font-size: .9em;\n  }\n\n  app-tab {\n    .pane {\n      padding: 0px !important;\n    }\n\n    li {\n      width: 100%;\n    }\n  }\n}\n\n\n#voice-message {\n  width: 80% !important;\n  position: relative;\n  background: #fff;\n  margin-top: -50px;\n  margin-left: 10px;\n  padding-right: 10px;\n  height: 50px;\n\n  span {\n    display: inline-block;\n    color: #999;\n  }\n}\n\n#chat-tools {\n  display: flex;\n  list-style-type: none;\n  width: 60px;\n  flex-direction: row;\n  gap: 20px;\n  padding: 0px;\n  margin: 0px;\n  position: relative;\n  right: 10px;\n\n  .fa-paper-plane {\n    font-size: 17px !important;\n  }\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.comment-area-box::after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 1px;\n  left: 99%;\n  box-sizing: border-box;\n  border: 10px solid rgba(0, 0, 0, 0.5);\n  border-color: transparent transparent #fff #fff;\n  transform-origin: 0 0;\n  transform: rotate(135deg);\n  box-shadow: -1px 1px 1px 0 rgba(0, 0, 0, 0.35);\n}\n\n.comment-area-box {\n  // position: absolute;\n  // z-index: 999;\n  // top:40px;\n  // right:0px;\n  display: none;\n  background: #fff;\n  padding: 15px 10px 5px;\n  // box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 5px;\n  width: 80%;\n\n  label {\n    width: fit-content !important;\n  }\n\n  textarea {\n    resize: none;\n  }\n\n  .form-btns {\n    width: 100%;\n    display: flex;\n    margin: 5px 0px;\n\n    .btn:first-child {\n      border: 1px solid #dbdbdb;\n      background: #fff !important;\n      color: #000 !important;\n    }\n\n    .btn {\n      --bs-btn-line-height: 1.2 !important;\n      font-size: .9rem !important;\n      padding: 5px 20px;\n      color: #fff;\n      background: var(--primaryColor);\n      margin-right: 15px;\n      border: none;\n      cursor: pointer;\n      font-family: \"Noto Sans\", sans-serif;\n    }\n  }\n\n\n}\n\n.comment-area-box.is-active {\n  display: flex;\n  margin-top: 10px;\n  align-items: center;\n}\n\n.comment-form {\n  margin-left: 10px;\n  margin-top: 10px;\n\n  label {\n    font-size: .9rem;\n  }\n\n  textarea {\n    margin-right: 25px;\n  }\n\n  .comments-field {\n    margin-top: 10px;\n\n    .form-btns {\n      float: right;\n    }\n  }\n\n  .button {\n    &:hover {\n      background: var(--primaryColor) !important;\n      color: #fff !important;\n    }\n  }\n}\n\n.chat-icon:has(> .bot-icon) {\n  position: sticky;\n  top: 0;\n  margin-bottom: 40px;\n}\n\n::ng-deep .formatted-table {\n  border-collapse: collapse;\n  width: 100%;\n  margin: 20px 0;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  font-size: 14px;\n}\n\n::ng-deep .formatted-table th {\n  background: linear-gradient(135deg, #34495e, #2c3e50);\n  color: white;\n  padding: 15px 12px;\n  text-align: left;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  border: none;\n}\n\n::ng-deep .formatted-table td {\n  padding: 12px;\n  border-bottom: 1px solid #ecf0f1;\n  border-right: 1px solid #ecf0f1;\n  vertical-align: top;\n  transition: background-color 0.2s ease;\n}\n\n::ng-deep .formatted-table tr:hover td {\n  background-color: #f8f9fa;\n}\n\n::ng-deep .formatted-table tr:nth-child(even) td {\n  background-color: #fdfdfd;\n}\n\n::ng-deep .formatted-table tr:last-child td {\n  border-bottom: none;\n}\n\n::ng-deep .formatted-table td:last-child {\n  border-right: none;\n}\n\n/* Heading Styles */\n::ng-deep .formatted-heading {\n  color: #2c3e50;\n  margin: 15px 0 15px 0;\n  font-weight: 600;\n  position: relative;\n}\n\n::ng-deep .formatted-heading.h1 {\n  font-size: 1.5em;\n  border-bottom: 3px solid #3498db;\n  padding-bottom: 10px;\n}\n\n::ng-deep .formatted-heading.h2 {\n  font-size: 1em;\n  border-bottom: 2px solid #3498db;\n  padding-bottom: 8px;\n  line-height: 2;\n}\n\n::ng-deep .formatted-heading.h3 {\n  font-size: 1em;\n  color: #34495e;\n  line-height: 2;\n}\n\n::ng-deep .formatted-heading.h4 {\n  font-size: 1.2em;\n  color: #34495e;\n}\n\n::ng-deep .formatted-heading.h5 {\n  font-size: 1.1em;\n  color: #34495e;\n}\n\n::ng-deep .formatted-heading.h6 {\n  font-size: 1em;\n  color: #34495e;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n::ng-deep .formatted-list{\n  margin-top: -1.5rem;\n}\n\n.timestamp-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-bottom: 30px;\n  padding: 0 10px;\n\n  .timestamp-icon {\n    opacity: 0.7;\n  }\n}\n\n@media screen and (max-width:640px) {\n\n  .chat-icon:has(> .bot-icon) {\n    position: sticky;\n    top: 0;\n    margin-bottom: 40px;\n  }\n\n  .chat-list-row {\n    width: 98%;\n  }\n\n  .answer-header {\n    justify-content: flex-end;\n  }\n\n  .menu-list {\n    margin-top: 10px;\n  }\n}\n\n@media screen and (min-width:768px) and (max-width:960px) {\n  #chat-list-content {\n    padding: 1% 3% 0% 1% !important;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
